var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 11.5C22.9 5.1 17.8 0 11.5 0S0 5.1 0 11.5 5.1 23 11.5 23s11.4-5.2 11.4-11.5zm-11.4 8.8c-4.9 0-8.8-3.9-8.8-8.8s3.9-8.8 8.8-8.8 8.8 3.9 8.8 8.8-4 8.8-8.8 8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 21.7l-2.1-2.1c-.5-.5-1.4-.5-1.9 0s-.5 1.4 0 1.9l2.1 2.1c.3.3.6.4.9.4.3 0 .7-.1.9-.4.6-.5.6-1.4.1-1.9z"
  })));
}
export default SvgSearch;